import { render } from "./indicator-table.vue?vue&type=template&id=58cd4113"
import script from "./indicator-table.vue?vue&type=script&lang=js"
export * from "./indicator-table.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__